module.exports = __webpack_public_path__ + "img/3.0d896a29.png";